import { Typography } from '@mui/material';

export const Users = ({ dataUsers }) => {
    return (
        <Typography
            variant="body2"
            color={
                dataUsers.length
                ? 'text.primary'
                : 'text.secondary'
            }
            sx={{
                mt: 2,
                mb: 2,
                flexGrow: 1,
                overflowWrap: 'anywhere',
            }}
        >
        {dataUsers.length
            ? dataUsers
                .map(
                    (user) =>
                        user.nombre || user.usuario
                    )
                    .join(' · ')
            : 'Esta caja aún no tiene usuarios asignados.'}
        </Typography>
    )
}
